import { render, staticRenderFns } from "./BlackCurrentConsume.vue?vue&type=template&id=58514d2c&scoped=true&"
import script from "./BlackCurrentConsume.vue?vue&type=script&lang=js&"
export * from "./BlackCurrentConsume.vue?vue&type=script&lang=js&"
import style0 from "./BlackCurrentConsume.vue?vue&type=style&index=0&id=58514d2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58514d2c",
  null
  
)

export default component.exports